import { modalQuickMenuStore } from '@/utils/store-accessor'

export class ModalQuickMenuService {
  public open() {
    modalQuickMenuStore.open()
  }

  public close() {
    modalQuickMenuStore.close()
  }
}
